import 'picturefill';
import objectFitImages from 'object-fit-images';
import Scrollbar from 'smooth-scrollbar';
import 'slick-carousel';
import AOS from 'aos';

import lozad from 'lozad';
const observer = lozad();
observer.observe();

$(function () {
	objectFitImages($('.object-fit'));
	objectFitImages($('.object-contain'));
});

$(window).on('load', function () {

	// body preload
	$('.preload').removeClass('active');

	if (localStorage.cookiesConsent != "true") {
		$(".cookies").removeClass("cookies-hide");
	}

	$(".btn--cookies").on('click', function () {
		$(".cookies").addClass("cookies-hide");
		localStorage.setItem('cookiesConsent', 'true');
	});

	if ($('.scroll-wrapper').length > 0) {
		Scrollbar.init(document.querySelector('.scroll-wrapper'));
	}

});

$(document).ready(function () {

	// $("body").html(
	// 	$("body").html().replace("paragon oak", "<sup>&reg;</sup>")
	// ); 

	AOS.init();

	if ($(window).width() < 1024) {
		$('.sticky-email').appendTo($('.header .container'));
		$('.feature-project .btn').appendTo($('.feature-project__left'));

		$('.menu-item-has-children').on('click', function () {

			$(this).children('.sub-menu').slideToggle();
		});
	}

	$('.header .burger-btn').on('click', function () {
		$(this).toggleClass('active');
		$('.header__nav').toggleClass('active');
		$('body').toggleClass('no-scroll');
	});

	/* Generic Sliders */

	$('.mobile-slider').each(function () {

		$(this).slick({
			slide: '.mobile-slider__item',
			rows: 0,
			// autoplay: true,
			// autoplaySpeed: 5000,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			fade: false,
			infinite: true,
			draggable: true,
			arrows: false,
			dots: true,
			appendDots: $(this).children('.mobile-slider__dots'),
			centerMode: true,
			centerPadding: '50px',
			slidesToShow: 1,
		})
	});

	$('.big-boxes .flex').slick({
		slide: '.big-boxes__item',
		rows: 0,
		// autoplay: true,
		// autoplaySpeed: 5000,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		fade: false,
		infinite: true,
		draggable: true,
		arrows: false,
		dots: true,
		appendDots: '.mobile-slider__dots-2',
		mobileFirst: true,
		centerMode: true,
		slidesToShow: 1,
		centerPadding: '0px',
		responsive: [
			{
				breakpoint: 1023,
				settings: "unslick"
			}
		]
	});

	// $('.image-slider').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	fade: false,
	// 	draggable: false,
	// 	// autoplay: true,
	// 	// autoplaySpeed: 1000
	// 	asNavFor: '.bio-slider'
	//   });
		/* template-our-roots */
	//   $('.bio-slider').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.image-slider',
	// 	dots: false,
	// 	// appendDots: '.slider-wrapper__dots',
	// 	arrows: false
	// 	// centerMode: true,
	// 	// focusOnSelect: true
	//   });

	// var selectLength2 = ($('.service-select-2 option:selected').text().length * 2.3 ) * 10;
	// $('.service-select-2').outerWidth(selectLength2, true);

	// $('.service-select-2').on('change', function() {
	// 	$(this).outerWidth(selectLength2, true)
	// })

	// console.log(selectLength);

});



var lastScrollTop = 0;

$(window).scroll(function (event) {

	var st = $(this).scrollTop();

	if (st >= lastScrollTop && st >= 1) {
		// downscroll code
		$('.header').addClass('header--slide-up').removeClass('header--active');


	} else {
		// upscroll code
		// $('.header').addClass('nav-is-active');
		$('.header').removeClass('header--slide-up').addClass('header--active');

	}

	lastScrollTop = st;

	if (st == 0) {
		$('.header').removeClass('header--slide-up').removeClass('header--active');
	}

});
